import { gql } from "@apollo/client";

const SAVE_VISITA_BOMBA_AP = gql`
    mutation saveVisitaBombaInfusionAP($input: AddVisitaBombaInfusionInput!, $idTeleEnfermeria: Int!){
        saveVisitaBombaInfusionAP(input: $input, idTeleEnfermeria: $idTeleEnfermeria) {
            idBombaInfusionTelemedicina
        }
    }
`;

export default SAVE_VISITA_BOMBA_AP;

export const addVisitaBombaInfusionInput = (data) => ({
  idTeleEnfermeria: data?.idTeleEnfermeriaAP,
  input: {
    idBombaInfusionTelemedicina: data?.idBombaInfusionTelemedicina,
    estaEnchufada: !!data?.estaEnchufada,
    funcionamientoAdecuado: !!data?.funcionamientoAdecuado,
    remanenteBolsa: data?.remanenteBolsa,
    mantenimientoBomba: data?.mantenimientoBomba,
    alarmasSuenan: !!data?.alarmasSuenan,
    modeloBomba: data?.modeloBomba,
    reemplazoBomba: data?.reemplazoBomba,
    velocidadAdministraForm: data?.velocidadAdministraForm
  }
});